<template>
  <nav class="m-parts">
    <a
      v-for="p in parts"
      :key="p.key"
      :href="p.href"
      class="m-parts__item"
      :class="{ 'is-active': p.key === active }"
    >
      <CygnusIcon v-if="p.icon" :name="p.icon" /><span>{{ p.label }}</span>
    </a>
  </nav>
</template>

<script>
/**
 * MusubiPartSwitcher — the top-level Acquire / Outreach / Analytics switcher
 * (the platform's three parts). Presentational; links to each part's landing
 * route. Defaults provided; override `parts` to relabel/re-point.
 *
 *   <MusubiPartSwitcher active="acquire" />
 */
export default {
  name: 'MusubiPartSwitcher',
  props: {
    /** acquire | outreach | analytics */
    active: { type: String, required: true },
    parts: {
      type: Array,
      default: () => [
        { key: 'acquire',   label: 'Acquire',   icon: 'broadcast',  href: '/acquire' },
        { key: 'outreach',  label: 'Outreach',  icon: 'envelope',   href: '/outreach' },
        { key: 'analytics', label: 'Analytics', icon: 'chart-line', href: '/analytics' },
      ],
    },
  },
};
</script>

<style scoped>
.m-parts { display: inline-flex; gap: 4px; background: var(--m-bg-content); border: 1px solid var(--m-border); border-radius: var(--m-radius-lg); padding: 4px; }
.m-parts__item {
  display: inline-flex; align-items: center; gap: 8px; padding: 7px 15px; border-radius: var(--m-radius);
  color: var(--m-text-secondary); font-weight: 600; font-size: 0.82rem; text-decoration: none;
}
.m-parts__item:hover { color: var(--m-text-primary); }
.m-parts__item.is-active { background: var(--m-bg-card); color: var(--m-accent); box-shadow: var(--m-shadow-card); }
.m-parts__item i { font-size: 0.85rem; }
</style>
